"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var installation_level_setting_component_1 = __importDefault(require("./installation-level-setting.component"));
var styled_components_1 = __importDefault(require("styled-components"));
var calculate_setting_position_1 = __importDefault(require("../utils/calculate-setting-position"));
var installation_sketch_constants_1 = __importDefault(require("../installation-sketch-constants"));
var SettingContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  left: ", ";\n  right: ", ";\n  transform: ", ";\n  transition: bottom ease-in 0.4s;\n  height: 14px;\n"], ["\n  position: absolute;\n  left: ",
    ";\n  right: ",
    ";\n  transform: ",
    ";\n  transition: bottom ease-in 0.4s;\n  height: 14px;\n"])), function (_a) {
    var width = _a.width, side = _a.side;
    return "" + (side === 'left' || side === undefined ? Math.floor(width * installation_sketch_constants_1.default.leftBreakPoint) + 'px' : '');
}, function (_a) {
    var width = _a.width, side = _a.side;
    return "" + (side === 'right' ? Math.floor(width * installation_sketch_constants_1.default.rightBreakPoint) + 'px' : '');
}, function (_a) {
    var side = _a.side;
    return "translate(calc( " + (side === 'right' ? '' : '-') + "100% " + (side === 'right' ? '-' : '+') + " " + installation_sketch_constants_1.default.dashLength + "px), calc(50% - 8px))";
});
SettingContainer.displayName = 'SettingContainer';
var Setting = function (_a) {
    var setting = _a.setting, width = _a.width;
    return (react_1.default.createElement(SettingContainer, { style: { bottom: setting.position + "px" }, width: width, side: setting.side },
        react_1.default.createElement(installation_level_setting_component_1.default, __assign({}, setting))));
};
var InstallationSettings = function (_a) {
    var height = _a.height, width = _a.width, settings = _a.settings, highestSetting = _a.highestSetting;
    var positionSettings = settings.map(function (setting) {
        return __assign(__assign({}, setting), { position: 0, offset: 0 });
    });
    var calSetting = { screenHeight: height, highestSetting: highestSetting };
    var sortedSettings = positionSettings.sort(function (a, b) { return b.value - a.value; });
    sortedSettings.forEach(function (setting, index) {
        var prevSetting = index === 0 ? undefined : sortedSettings[index - 1];
        var settingsPosition = calculate_setting_position_1.default(calSetting, setting, prevSetting);
        sortedSettings[index].position = settingsPosition.position;
        sortedSettings[index].offset = settingsPosition.offset;
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, sortedSettings.map(function (setting, index) { return (react_1.default.createElement(Setting, { key: index, setting: setting, width: width })); })));
};
exports.default = InstallationSettings;
var templateObject_1;
